import PDPGalleryModal from './pdp-gallery-modal';
import { PDPGallery } from './pdp-gallery';

class GalleryModalToggle extends HTMLElement {
  modal: PDPGalleryModal | null = null;
  toggleBtn: HTMLElement | null = null;
  gallery: PDPGallery | null = null;

  connectedCallback() {
    this.modal = document.querySelector('pdp-gallery-modal') as PDPGalleryModal;
    this.toggleBtn = this.querySelector('#gallery-modal-toggle');
    this.slider = document.querySelector('pdp-gallery') as PDPGallery;

    this.toggleBtn?.addEventListener('click', () => {
      this.modal?.show();
      const position = this.dataset.position;

      if (this.slider) {
        this.slider.jumpToIndex(position - 1);
      }
    });
  }
}

if (!customElements.get('gallery-modal-toggle')) {
  window.customElements.define('gallery-modal-toggle', GalleryModalToggle);
}
